module.exports = __webpack_public_path__ + "img/languette.1d05ad14.svg";